import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    tabindex: "-1",
    "aria-hidden": "true",
    class: "fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full bg-darkend"
};
const _hoisted_2 = { class: "flex items-center justify-center h-screen" };
const _hoisted_3 = ["onSubmit"];
const _hoisted_4 = { class: "relative bg-white rounded-lg shadow dark:bg-gray-700" };
const _hoisted_5 = { class: "p-6 space-y-6" };
const _hoisted_6 = { class: "block" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "text-grey-300 text-xs" }, "Name des Projekts:", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "text-grey-300 text-xs" }, "Erlaubte Zeichen a-Z und 0-9 sowie Binde- u. Unterstriche. Keine Sonder- oder Leerzeichen verwenden.", -1);
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalComponent',
    emits: ["onSubmitForm"],
    setup(__props, { emit: emits }) {
        let projectname = ref('');
        const submitForm = () => {
            emits('onSubmitForm', projectname.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, {
                name: "modal",
                "enter-from-class": "opacity-0",
                "enter-to-class": "opacity-100",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0",
                "enter-active-class": "ease-out duration-300",
                "leave-active-class": "ease-in duration-300"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(submitForm, ["prevent"]),
                                class: "relative w-full h-full max-w-2xl md:h-auto"
                            }, [
                                _createElementVNode("div", _hoisted_4, [
                                    _renderSlot(_ctx.$slots, "header"),
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("label", _hoisted_6, [
                                            _hoisted_7,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(projectname) ? (projectname).value = $event : projectname = $event)),
                                                type: "text",
                                                minlength: "3",
                                                maxlength: "125",
                                                pattern: "^[a-zA-Z0-9._-]{3,125}$",
                                                class: "mt-1 block w-full rounded-md border-orange shadow-sm focus:border-orange focus:ring focus:ring-orange focus:ring-opacity-50",
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(projectname)]
                                            ])
                                        ]),
                                        _hoisted_8
                                    ]),
                                    _renderSlot(_ctx.$slots, "footer")
                                ])
                            ], 40, _hoisted_3)
                        ])
                    ])
                ]),
                _: 3
            }));
        };
    }
});
